{
  "journalAudit.action.design.org_charter.applied": "Version de la charte de l’organisation appliquée",
  "journalAudit.action.design.org_charter.refused": "Version de la charte de l’organisation refusée",
  "v8b.charte.adresse_invalide": "Adresse invalide : aucune version ne porte ce numéro.",
  "v8b.charte.annuler": "Annuler",
  "v8b.charte.appliquee": "Version appliquée aux projets",
  "v8b.charte.appliquee_info": "v{{version}} ({{semver}}), {{regime}}, validée par {{qui}} le {{le}}.",
  "v8b.charte.appliquer.bouton": "Appliquer la version",
  "v8b.charte.appliquer.effet_aucun": "Aucun projet n’a de surcharge ouverte : la version remplace l’actuelle pour tous.",
  "v8b.charte.appliquer.effet_projets": "{{n}} projet(s) touché(s), leur surcharge ouverte devient sans objet : {{projets}}.",
  "v8b.charte.appliquer.succes": "Version appliquée. Écrit au journal.",
  "v8b.charte.appliquer.succes_projets": "Version appliquée ; projets touchés : {{projets}}. Écrit au journal.",
  "v8b.charte.appliquer.titre": "Appliquer la version {{version}}",
  "v8b.charte.appliquer.verbe": "Appliquer",
  "v8b.charte.aucune_surcharge": "Aucun projet n’a demandé de surcharge.",
  "v8b.charte.aucune_validee": "Aucune version validée : chaque projet applique la sienne.",
  "v8b.charte.aucune_version": "Aucune version de la charte : composez-en une.",
  "v8b.charte.champ.angles": "Angles",
  "v8b.charte.champ.densite": "Densité",
  "v8b.charte.champ.fond": "Fond de page",
  "v8b.charte.champ.logo": "Logo",
  "v8b.charte.champ.palette": "Couleur principale",
  "v8b.charte.champ.typographie": "Typographie",
  "v8b.charte.champ.voix": "Voix des libellés",
  "v8b.charte.choix.angles.auto": "Selon la typographie",
  "v8b.charte.choix.angles.doux": "Arrondis",
  "v8b.charte.choix.angles.droits": "Droits",
  "v8b.charte.choix.angles.legers": "Légèrement arrondis",
  "v8b.charte.choix.angles.ronds": "Très arrondis",
  "v8b.charte.choix.densite.aeree": "Aérée",
  "v8b.charte.choix.densite.compacte": "Compacte",
  "v8b.charte.choix.densite.standard": "Standard",
  "v8b.charte.choix.fond.blanc": "Blanc",
  "v8b.charte.choix.fond.chaud": "Beige chaud",
  "v8b.charte.choix.fond.froid": "Gris bleuté",
  "v8b.charte.choix.fond.neutre": "Gris neutre",
  "v8b.charte.choix.fond.personnalisee": "Autre fond",
  "v8b.charte.choix.logo.aucun": "Aucun",
  "v8b.charte.choix.logo.initiales": "Initiales",
  "v8b.charte.choix.logo.nom": "Logo texte",
  "v8b.charte.choix.palette.bleu-nuit": "Bleu nuit",
  "v8b.charte.choix.palette.brique": "Brique",
  "v8b.charte.choix.palette.olive": "Olive",
  "v8b.charte.choix.palette.personnalisee": "Autre couleur",
  "v8b.charte.choix.palette.sarcelle": "Sarcelle",
  "v8b.charte.choix.typographie.chaleureuse": "Chaleureuse",
  "v8b.charte.choix.typographie.sobre": "Sobre",
  "v8b.charte.choix.typographie.technique": "Technique",
  "v8b.charte.choix.voix.tutoiement": "Tutoiement",
  "v8b.charte.choix.voix.vouvoiement": "Vouvoiement",
  "v8b.charte.choix_en_mots": "Choix en mots",
  "v8b.charte.code.COMPOSITION_HORS_MODELE": "Le modèle du projet n’a pas d’application : aucune composition.",
  "v8b.charte.code.CONTEXTE_INCOMPLET": "Contexte incomplet : la décision ne peut pas être jugée.",
  "v8b.charte.code.CREATEUR_N_APPROUVE_PAS": "Vous l’avez demandée : une autre personne doit décider.",
  "v8b.charte.code.DESIGN_CHARTER_NOT_DRAFT": "Seul un brouillon se valide.",
  "v8b.charte.code.DESIGN_CHARTER_OUTDATED": "Version antérieure à la version appliquée.",
  "v8b.charte.code.DESIGN_CONTRAST_INSUFFICIENT": "Contraste insuffisant : la passerelle refuse cette version.",
  "v8b.charte.code.DESIGN_ORG_CHARTER_ENFORCEMENT_REFUSED": "Seule la version appliquée change de régime.",
  "v8b.charte.code.DESIGN_OVERRIDE_EXPIRED": "Surcharge échue : le projet doit en demander une nouvelle.",
  "v8b.charte.code.DESIGN_OVERRIDE_NOT_FOUND": "Surcharge introuvable.",
  "v8b.charte.code.DESIGN_OVERRIDE_NOT_OPEN": "Surcharge déjà décidée ou close.",
  "v8b.charte.code.DESIGN_OVERRIDE_SELF_DECISION_REFUSED": "Vous l’avez demandée : une autre personne doit décider.",
  "v8b.charte.code.DESIGN_SELF_VALIDATION_REFUSED": "L’auteur d’une version ne la valide jamais lui-même.",
  "v8b.charte.code.DROIT_NON_TENU": "Votre profil ne tient pas le droit requis.",
  "v8b.charte.code.GARDE_DROIT_ABSENTE": "Opération sans garde déclarée : refusée.",
  "v8b.charte.code.IDEMPOTENCE_CONFLIT": "Demande déjà envoyée avec un autre contenu.",
  "v8b.charte.code.REFERENTIEL_ETAT_INCOMPATIBLE": "Geste hors de l’état attendu de l’objet.",
  "v8b.charte.code.REFERENTIEL_MOTIF_REQUIS": "Motif absent ou trop court.",
  "v8b.charte.code.REFERENTIEL_REPRISE_IMPOSSIBLE": "Reprise impossible : version source introuvable ou déjà validée.",
  "v8b.charte.code.RESOURCE_UNAVAILABLE": "Introuvable dans votre organisation.",
  "v8b.charte.code.SANS_SESSION": "Session expirée : reconnectez-vous.",
  "v8b.charte.code.TECHNOLOGIE_NON_PROPOSABLE": "Pile non qualifiée : demandez une dérogation.",
  "v8b.charte.code.VALIDATION_ERROR": "Un champ obligatoire manque ou sort du domaine.",
  "v8b.charte.code.VALIDATION_PAR_UN_TIERS": "Une autre personne doit valider : l’auteur ou un contributeur de la version ne le fait jamais.",
  "v8b.charte.code.WORKSPACE_ARCHIVED": "Projet archivé : rien ne s’y écrit.",
  "v8b.charte.composant.actuel": "{{role}} : {{element}}, {{n}} liaison(s).",
  "v8b.charte.composant.ajoute": "Composant ajouté au brouillon du lancement.",
  "v8b.charte.composant.ajouter": "Ajouter le composant",
  "v8b.charte.composant.aucune_liaison": "Aucune liaison possible : aucun autre rôle compatible n’est présent.",
  "v8b.charte.composant.aucune_pile": "Aucun élément qualifié pour ce rôle.",
  "v8b.charte.composant.choisir": "— choisir —",
  "v8b.charte.composant.element": "Élément (pile qualifiée)",
  "v8b.charte.composant.element_requis": "Choisissez un élément.",
  "v8b.charte.composant.enregistrer": "Enregistrer les modifications",
  "v8b.charte.composant.incompatible": "Liaison devenue incompatible {{de}} → {{vers}} ({{motif}}) : retirez-la ou remplacez-la.",
  "v8b.charte.composant.lecture": "le lancement du projet",
  "v8b.charte.composant.lecture_piles": "les piles du catalogue",
  "v8b.charte.composant.liaison": "{{de}} → {{vers}}",
  "v8b.charte.composant.liaisons": "Liaisons",
  "v8b.charte.composant.modifie": "Composant modifié dans le brouillon du lancement.",
  "v8b.charte.composant.non_qualifie": "{{pile}} (actuelle, plus qualifiée)",
  "v8b.charte.composant.non_qualifiee": "Composition non qualifiée :",
  "v8b.charte.composant.pas": "Pas {{k}} sur 3",
  "v8b.charte.composant.qualifiee": "Composition qualifiée.",
  "v8b.charte.composant.retire": "Ce composant a été retiré entre-temps.",
  "v8b.charte.composant.retour": "Retour au lancement",
  "v8b.charte.composant.rien": "Rien à enregistrer : aucune modification.",
  "v8b.charte.composant.role": "Rôle",
  "v8b.charte.composant.roles_pris": "Chaque rôle a déjà son composant : modifiez-en un.",
  "v8b.charte.composant.titre_ajouter": "Ajouter un composant au projet",
  "v8b.charte.composant.titre_modifier": "Modifier un composant du projet",
  "v8b.charte.contraste.conforme": "conforme",
  "v8b.charte.contraste.insuffisant": "insuffisant",
  "v8b.charte.editeur.apercu_bouton": "Aperçu d’un bouton",
  "v8b.charte.editeur.apercu_texte.tutoiement": "Tu peux enregistrer ton travail.",
  "v8b.charte.editeur.apercu_texte.vouvoiement": "Vous pouvez enregistrer votre travail.",
  "v8b.charte.editeur.apercu_titre": "Votre organisation",
  "v8b.charte.editeur.attente_source": "La version reprise doit être lisible avant toute saisie.",
  "v8b.charte.editeur.choix": "Choix de la version",
  "v8b.charte.editeur.contraste_a_verifier": "Contraste vérifié à la saisie : saisissez une couleur valide.",
  "v8b.charte.editeur.contraste_conforme": "Contraste vérifié à la saisie : toutes les paires sont conformes.",
  "v8b.charte.editeur.couleur_libre": "Couleur principale (#rrggbb)",
  "v8b.charte.editeur.effet_brouillon": "Enregistrée en brouillon : une autre personne doit la valider.",
  "v8b.charte.editeur.effet_reprise": "Une révision liée à la version reprise est enregistrée ; l’ancienne validation tombe.",
  "v8b.charte.editeur.enregistrer": "Enregistrer la version",
  "v8b.charte.editeur.fond_libre": "Couleur du fond (#rrggbb)",
  "v8b.charte.editeur.logo_texte": "Texte du logo",
  "v8b.charte.editeur.nom": "Nouvelle version : v{{version}} (numéro attribué à l’enregistrement).",
  "v8b.charte.editeur.paire_insuffisante": "Contraste insuffisant : {{paire}} ({{ratio}}).",
  "v8b.charte.editeur.titre": "Charte de l’organisation — composer une version",
  "v8b.charte.effets.lecture": "les projets touchés",
  "v8b.charte.effets.non_visibles": "Les projets touchés ne sont pas visibles pour votre profil : la réponse les nommera.",
  "v8b.charte.etat.chargement": "Chargement de {{quoi}}…",
  "v8b.charte.etat.en_cours": "En cours…",
  "v8b.charte.etat.erreur": "{{quoi}} : lecture impossible pour le moment.",
  "v8b.charte.etat.reessayer": "Réessayer",
  "v8b.charte.etat.refus": "{{quoi}} : lecture refusée pour votre profil.",
  "v8b.charte.etat_version.appliquee_imposee": "Appliquée aux projets, imposée.",
  "v8b.charte.etat_version.appliquee_recommandee": "Appliquée aux projets, recommandée.",
  "v8b.charte.etat_version.brouillon": "Brouillon : une autre personne doit le valider.",
  "v8b.charte.etat_version.refusee_avec_motif_retour_a_l_auteur": "Refusée avec motif, retour à l’auteur.",
  "v8b.charte.etat_version.remplacee": "Remplacée par une version plus récente.",
  "v8b.charte.etat_version.validee_pas_encore_appliquee": "Validée, pas encore appliquée ({{regime}}).",
  "v8b.charte.fiche.applicateur": "Appliquée par",
  "v8b.charte.fiche.auteur": "Auteur",
  "v8b.charte.fiche.motif": "Refusée par {{qui}} : « {{motif}} ». Elle revient à son auteur.",
  "v8b.charte.fiche.source": "Reprise de",
  "v8b.charte.fiche.source_lien": "la version n° {{id}}",
  "v8b.charte.fiche.titre": "Version",
  "v8b.charte.fiche.validateur": "Validée par",
  "v8b.charte.fiche.version": "Numéro",
  "v8b.charte.geste.erreur": "Le geste n’a pas abouti. Réessayez dans un instant.",
  "v8b.charte.gestes": "Décisions",
  "v8b.charte.jetons.copier": "Copier les jetons",
  "v8b.charte.jetons.copies": "Jetons copiés.",
  "v8b.charte.jetons.masquer": "Masquer les jetons",
  "v8b.charte.jetons.voir": "Voir les jetons",
  "v8b.charte.lecture_charte": "la charte de l’organisation",
  "v8b.charte.lecture_source": "la version reprise",
  "v8b.charte.lecture_version": "la version de la charte",
  "v8b.charte.modifier": "Modifier la charte",
  "v8b.charte.n_a_decider": "{{n}} à décider",
  "v8b.charte.onglet.catalogue": "Catalogue technologique",
  "v8b.charte.onglet.charte": "Charte",
  "v8b.charte.onglet.chemin_dore": "Chemin doré",
  "v8b.charte.onglet.derogations": "Dérogations",
  "v8b.charte.onglet.exigences": "Exigences",
  "v8b.charte.onglet.regles": "Règles en trois temps",
  "v8b.charte.onglet.sante": "Santé de la conformité",
  "v8b.charte.onglets": "Gouvernance de l’organisation",
  "v8b.charte.origine.nouvelle_version_depuis_la_version_appliquee": "Nouvelle version, depuis la version appliquée.",
  "v8b.charte.origine.reprise_d_un_brouillon": "Reprise d’un brouillon.",
  "v8b.charte.origine.reprise_d_une_version_refusee_motif_affiche": "Reprise d’une version refusée : son motif est rappelé.",
  "v8b.charte.par_le": "par {{qui}} le {{le}}",
  "v8b.charte.refus.bouton": "Refuser la version",
  "v8b.charte.refus.motif": "Motif du refus",
  "v8b.charte.refus.motif_court": "Le motif doit compter {{n}} caractères au moins.",
  "v8b.charte.refus.succes": "Version refusée : elle revient à son auteur avec le motif.",
  "v8b.charte.regime.changer": "Changer de régime",
  "v8b.charte.regime.confirmer": "Confirmer",
  "v8b.charte.regime.effets_aucun": "Aucun projet n’a sa propre charte : rien ne change pour eux.",
  "v8b.charte.regime.effets_projets": "{{n}} projet(s) reviendront à la charte : {{projets}}.",
  "v8b.charte.regime.effets_surcharges": "Les surcharges de l’autre régime deviennent sans objet.",
  "v8b.charte.regime.imposee": "imposée",
  "v8b.charte.regime.intro": "Version {{version}}, aujourd’hui {{regime}}.",
  "v8b.charte.regime.je_confirme": "Je confirme le passage en « {{regime}} ».",
  "v8b.charte.regime.recommandee": "recommandée",
  "v8b.charte.regime.retour_version": "Revenir à la version",
  "v8b.charte.regime.succes": "Régime changé ({{regime}}) ; {{n}} surcharge(s) devenue(s) sans objet ; projets touchés : {{projets}}. Écrit au journal.",
  "v8b.charte.regime.titre": "Changer le régime de la charte — confirmation",
  "v8b.charte.regime.vise": "Régime visé",
  "v8b.charte.reprendre.brouillon": "Reprendre le brouillon",
  "v8b.charte.reprendre.refusee": "Reprendre la version refusée",
  "v8b.charte.role.donnees": "Données",
  "v8b.charte.role.interface": "Interface",
  "v8b.charte.role.service": "Service",
  "v8b.charte.role.service_de_plateforme": "Service de plateforme",
  "v8b.charte.sans_organisation": "Aucune organisation dans votre session : la charte n’est pas lisible.",
  "v8b.charte.source_introuvable": "Version à reprendre introuvable ou déjà validée : seule une version brouillon ou refusée se reprend.",
  "v8b.charte.source_motif": "Motif du refus : « {{motif}} »",
  "v8b.charte.source_reprise": "Version reprise : v{{version}}, son contenu est préchargé.",
  "v8b.charte.statut.draft": "Brouillon à valider",
  "v8b.charte.statut.refused": "Refusée",
  "v8b.charte.statut.superseded": "Remplacée",
  "v8b.charte.statut.validated": "Appliquée",
  "v8b.charte.statut.validated_pending": "Validée, à appliquer",
  "v8b.charte.surcharge.accorder": "Accorder la surcharge",
  "v8b.charte.surcharge.aucun_ecart": "Aucun écart déclaré.",
  "v8b.charte.surcharge.decidee": "Surcharge décidée. Écrit au journal.",
  "v8b.charte.surcharge.decideur": "Décidée par",
  "v8b.charte.surcharge.decision": "Décision",
  "v8b.charte.surcharge.demandeur": "Demandée par",
  "v8b.charte.surcharge.ecart": "{{choix}} : organisation {{organisation}}, projet {{projet}}",
  "v8b.charte.surcharge.ecarts": "Écarts à la charte",
  "v8b.charte.surcharge.echeance": "Échéance",
  "v8b.charte.surcharge.entre_temps": "Cette surcharge a été décidée entre-temps : la fiche est relue.",
  "v8b.charte.surcharge.etat.a_decider": "À décider",
  "v8b.charte.surcharge.etat.accordee": "Accordée",
  "v8b.charte.surcharge.etat.refusee": "Refusée",
  "v8b.charte.surcharge.etat.terminee": "Terminée",
  "v8b.charte.surcharge.fiche": "Surcharge",
  "v8b.charte.surcharge.introuvable": "Surcharge introuvable dans votre organisation.",
  "v8b.charte.surcharge.lecture": "la surcharge",
  "v8b.charte.surcharge.mettre_fin": "Mettre fin à la surcharge",
  "v8b.charte.surcharge.mettre_fin_effet": "Le projet {{projet}} revient à la charte de l’organisation.",
  "v8b.charte.surcharge.mettre_fin_verbe": "Mettre fin",
  "v8b.charte.surcharge.motif": "Motif",
  "v8b.charte.surcharge.motif_decision": "Motif de la décision",
  "v8b.charte.surcharge.projet": "Projet",
  "v8b.charte.surcharge.refuser": "Refuser la surcharge",
  "v8b.charte.surcharge.regime": "Charte visée",
  "v8b.charte.surcharge.statut.active": "Accordée",
  "v8b.charte.surcharge.statut.ended": "Terminée",
  "v8b.charte.surcharge.statut.refused": "Refusée",
  "v8b.charte.surcharge.statut.requested": "À décider",
  "v8b.charte.surcharge.statut_titre": "Statut",
  "v8b.charte.surcharge.terminee": "Surcharge terminée : le projet revient à la charte.",
  "v8b.charte.surcharge.titre": "Surcharge de la charte demandée par un projet",
  "v8b.charte.surcharges": "Surcharges des projets",
  "v8b.charte.surcharges_reservees": "Les surcharges de tous les projets sont réservées à l’administration de l’organisation.",
  "v8b.charte.titre": "Charte de l’organisation",
  "v8b.charte.toute_la_charte": "Toute la charte",
  "v8b.charte.validee_par": "validée par {{qui}}",
  "v8b.charte.valider.imposee": "Valider — imposée",
  "v8b.charte.valider.imposee_effet": "Une fois appliquée, la charte sera imposée : {{n}} projet(s) ayant leur propre charte y reviendront ({{projets}}).",
  "v8b.charte.valider.imposee_verbe": "Valider imposée",
  "v8b.charte.valider.recommandee": "Valider — recommandée",
  "v8b.charte.valider.succes": "Version validée, à appliquer : la version appliquée reste en place. Écrit au journal.",
  "v8b.charte.version_introuvable": "Version introuvable dans votre organisation.",
  "v8b.charte.version_n": "Version {{version}}",
  "v8b.charte.version_titre": "Charte de l’organisation — version",
  "v8b.charte.versions": "Versions de la charte",
  "v8b.charte.vous": "vous"
}
